import PaginationRequest from '@/common/pagination/entities/pagination-request'

export default class ClientConfigFilter {
  public paging: PaginationRequest = new PaginationRequest()
}
